import { twMerge } from 'tailwind-merge';

import { USStateObject } from '../../../constants/USstates/constants';
import { getRegionUrl, getSpeciesUrl } from '../../../helpers/urls';
import { InternalLink } from '../../Clickables/InternalLink/InternalLink';
import { ArrowRightIcon } from '../../Icons/ArrowRightIcon';
import { Text } from '../../Text/Text';
import { IStateDataSpeciesList } from '../helpers/buildStateDataSpecies';

interface IProps {
  selectedState: USStateObject;
  stateSpeciesList?: IStateDataSpeciesList;
  className: string;
}

/*
NB: These waters have been exported by the BI team directly from our production database and so
these links will not work on staging!
*/
export const SpeciesLinks = ({ selectedState, className, stateSpeciesList }: IProps) => {
  const countryId = 'US';
  const countryName = 'United States';
  const orderedSpecies = stateSpeciesList
    ? [...stateSpeciesList.stateSpeciesList].sort((a, b) => Number(b.catches) - Number(a.catches))
    : [];
  const titleText = `Most popular species in ${selectedState.stateName}`;
  const buttonText = `Explore ${selectedState.stateName}`;

  return (
    <div className={twMerge('mx-auto w-full sm:w-1/2', className)}>
      <Text variant="sm" className="mb-3">
        {titleText}
      </Text>

      <div className="flex flex-col gap-y-3">
        {orderedSpecies?.map(species => {
          const { fish_external_id, common_name } = species;
          return (
            <InternalLink to={getSpeciesUrl(fish_external_id, common_name)} key={fish_external_id}>
              <Text variant="md" className="mb-0 py-1">
                {common_name}
                <ArrowRightIcon size={18} className="ml-1" />
              </Text>
            </InternalLink>
          );
        })}
      </div>
      <div className="flex w-full justify-center sm:justify-start">
        <InternalLink
          to={getRegionUrl(countryId, selectedState.stateID, countryName, selectedState.stateName)}
          className="mt-6 h-min"
          variant="buttonSecondary"
        >
          {buttonText}
        </InternalLink>
      </div>
    </div>
  );
};
